import React from "react";
import { SelectPickerProps, SelectPicker } from "rsuite";

import { Label } from "../Label";

const SelectPickerInput = (props: SelectPickerProps<any> & { labelTitle?: string; labelClassName?: string }) => {
  const { labelTitle, labelClassName, ...pickerProps } = props;

  return (
    <>
      {labelTitle ? <Label title={labelTitle} className={labelClassName} /> : null}
      <SelectPicker {...pickerProps} />
    </>
  );
};

export default SelectPickerInput;
